<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="card-header text-left fixed-card-title2">
			<v-row no-gutters>
				<v-col class="align-center d-flex" cols="10">
					<v-toolbar-title>{{ $t('edit-vaccine-header') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>

		<v-card-text class="pt-4 pb-0 overflow-y-auto" style="height: calc(100vh - 205px)">
			<v-row dense class="ma-0">
				<v-col cols="12">
					<v-select
						outlined
						v-model="performedBy"
						:label="$t('staff')"
						:items="medicalStaff"
						return-object
						dense
						item-text="fullName"
						:menu-props="{ maxHeight: 200, offsetY: true }"
						hide-details>
						<template v-slot:item="{ item }">
							<span style="width: 100%">{{ item.fullName }} </span>
						</template>
					</v-select>
				</v-col>
				<v-col :cols="selectedVaccineName === 'Other' ? 6 : 12">
					<v-select
						v-model="selectedVaccineName"
						:items="vaccineNameTemplate"
						item-text="vaccineName"
						:label="$t('name')"
						outlined
						dense
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">{{ item.vaccineName }} </span>
								</template>
								<span>{{ item.description }}</span>
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
				<v-col v-if="selectedVaccineName === 'Other'" cols="6">
					<v-text-field v-model="otherVaccineName" :label="$t('name')" outlined dense hide-details />
				</v-col>
				<v-col :cols="selectedVaccineDose === 'Other' ? 6 : 12">
					<v-select
						v-model="selectedVaccineDose"
						:items="vaccineDoseTemplate"
						item-text="dose"
						:label="$t('dosage')"
						outlined
						dense
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">{{ item.dose }} </span>
								</template>
								<span>{{ item.description }}</span>
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
				<v-col v-if="selectedVaccineDose === 'Other'" cols="6">
					<v-text-field v-model="otherVaccineDose" :label="$t('dosage')" outlined dense hide-details />
				</v-col>
				<v-col :cols="selectedVaccineRoute === 'Other' ? 6 : 12">
					<v-select
						v-model="selectedVaccineRoute"
						:items="vaccineRouteTemplate"
						item-text="route"
						:label="$t('route')"
						outlined
						dense
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">{{ item.route }} </span>
								</template>
								<span>{{ item.description }}</span>
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
				<v-col v-if="selectedVaccineRoute === 'Other'" cols="6">
					<v-text-field v-model="otherVaccineRoute" :label="$t('route')" outlined dense hide-details />
				</v-col>
				<v-col :cols="selectedVaccineSite === 'Other' ? 6 : 12">
					<v-select
						v-model="selectedVaccineSite"
						:items="vaccineSiteTemplate"
						item-text="site"
						:label="$t('site')"
						outlined
						dense
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">{{ item.site }} </span>
								</template>
								<span>{{ item.description }}</span>
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
				<v-col v-if="selectedVaccineSite === 'Other'" cols="6">
					<v-text-field v-model="otherVaccineSite" :label="$t('site')" outlined dense hide-details />
				</v-col>
				<v-col :cols="selectedVaccineManufacturer === 'Other' ? 6 : 12">
					<v-select
						v-model="selectedVaccineManufacturer"
						:items="vaccineManufacturerTemplate"
						item-text="manufacturer"
						:label="$t('manufacturer')"
						outlined
						dense
						hide-details
						:menu-props="{ maxHeight: 199, offsetY: true }">
						<template v-slot:item="{ item }">
							<v-tooltip left>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on" style="width: 100%">{{ item.manufacturer }} </span>
								</template>
								<span>{{ item.description }}</span>
							</v-tooltip>
						</template>
					</v-select>
				</v-col>
				<v-col v-if="selectedVaccineManufacturer === 'Other'" cols="6">
					<v-text-field v-model="otherVaccineManufacturer" :label="$t('manufacturer')" outlined dense hide-details />
				</v-col>
				<v-col cols="12">
					<v-menu
						v-model="dateMenu"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="auto">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="formattedDate"
								:label="$t('vaccination-date-header')"
								prepend-inner-icon="mdi-calendar"
								readonly
								outlined
								dense
								hide-details
								v-bind="attrs"
								v-on="on" />
						</template>
						<v-date-picker v-model="vaccinationDate" no-title @input="dateMenu = false" />
					</v-menu>
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="lotNumber"
						:label="$t('lot-number-header')"
						outlined
						dense
						hide-details
						@keypress="filterNumbersOnly" />
				</v-col>
				<v-col cols="12">
					<v-textarea outlined dense v-model="notes" :label="$t('notes')" hide-details no-resize rows="8" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense class="ma-0">
				<v-col cols="12" class="mx-0">
					<InputTimeFormatter
						:inputValue="timeSpentSeconds"
						@update:inputValue="(val) => (timeSpentSeconds = val)"
						:inputLabel="$t('time-spent')" />
				</v-col>
			</v-row>
			<v-row dense class="ma-0">
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>{{ $t('cancel') }}</v-btn>
				</v-col>
				<v-tooltip top v-if="!editButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('add') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="updateVaccine()" color="dark_purple" style="color: white" block>
						{{ $t('update') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getRowsForDataTable, formatTimestamp } from '../../utils/utilities';
import InputTimeFormatter from '../Client/components/InputTimeFormatter.vue';

export default {
	name: 'CCMVaccineAdd',
	components: { InputTimeFormatter },
	data () {
		return {
			medicalStaff: null,
			timeSpentSeconds: 0,
			performedBy: null,
			vaccineNameTemplate: null,
			vaccineDoseTemplate: null,
			vaccineRouteTemplate: null,
			vaccineSiteTemplate: null,
			vaccineManufacturerTemplate: null,
			selectedVaccineName: '',
			selectedVaccineDose: '',
			selectedVaccineRoute: '',
			selectedVaccineSite: '',
			selectedVaccineManufacturer: '',
			otherVaccineName: '',
			otherVaccineDose: '',
			otherVaccineRoute: '',
			otherVaccineSite: '',
			otherVaccineManufacturer: '',
			dateMenu: false,
			vaccinationDate: new Date().toISOString().substring(0, 10),
			lotNumber: '',
			notes: '',
		};
	},
	computed: {
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			currentRecord: (state) => state.ccmRecords.ccmRecord,
			roleList: (state) => state.roles.roles,
			selectedVaccine: (state) => state.ccmVaccines.ccmVaccine,
		}),
		editButtonEnabled () {
			return (
				this.timeSpentSeconds &&
				(this.selectedVaccineName !== 'Other' || this.otherVaccineName.trim()) &&
				(this.selectedVaccineSite !== 'Other' || this.otherVaccineSite.trim()) &&
				(this.selectedVaccineRoute !== 'Other' || this.otherVaccineRoute.trim()) &&
				(this.selectedVaccineDose !== 'Other' || this.otherVaccineDose.trim()) &&
				(this.selectedVaccineManufacturer !== 'Other' || this.otherVaccineManufacturer.trim()) &&
				this.lotNumber.trim() &&
				this.notes.trim() &&
				this.timeSpentSeconds <= 7200
			);
		},
		formattedDate () {
			return this.formatTimestamp(this.vaccinationDate);
		},
	},

	methods: {
		...mapActions({
			getVaccineNameTemplate: 'ccmRecords/getVaccineNameTemplate',
			getVaccineSiteTemplate: 'ccmRecords/getVaccineSiteTemplate',
			getVaccineRouteTemplate: 'ccmRecords/getVaccineRouteTemplate',
			getVaccineDoseTemplate: 'ccmRecords/getVaccineDoseTemplate',
			getVaccineManufacturerTemplate: 'ccmRecords/getVaccineManufacturerTemplate',
			updateCCMVaccine: 'ccmVaccines/updateCCMVaccine',
		}),
		getRowsForDataTable,
		formatTimestamp,

		closeDrawer () {
			this.timeSpentSeconds = 0;
			this.dateMenu = false;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},

		async updateVaccine () {
			const request = {
				id: this.selectedVaccine.id,
				body: {
					ccmRecordId: this.currentRecord.id,
					patientId: this.currentRecord.patientId,
					hospitalId: this.currentRecord.hospitalId,
					vaccinationDate: new Date(this.vaccinationDate).toISOString(),
					vaccineName: this.selectedVaccineName === 'Other' ? this.otherVaccineName : this.selectedVaccineName,
					dose: this.selectedVaccineDose === 'Other' ? this.otherVaccineDose : this.selectedVaccineDose,
					route: this.selectedVaccineRoute === 'Other' ? this.otherVaccineRoute : this.selectedVaccineRoute,
					site: this.selectedVaccineSite === 'Other' ? this.otherVaccineSite : this.selectedVaccineSite,
					manufacturer:
						this.selectedVaccineManufacturer === 'Other'
							? this.otherVaccineManufacturer
							: this.selectedVaccineManufacturer,
					lotNumber: this.lotNumber,
					notes: this.notes,
					performedBy: this.performedBy.fullName,
					performedByRole: this.roleList.find((item) => item.id === this.performedBy.roleId).roleName,
					staffId: this.performedBy.id,
					timeSpentSeconds: this.timeSpentSeconds,
					additionalData: '',
				},
			};
			this.updateCCMVaccine(request);
			this.closeDrawer();
		},

		filterMedicalStaff () {
			return this.detailedUser.userData.medicalTeamsData[0].membersList
				.filter((member) => (member.roleId === 3 || member.roleId === 4) && member.isSequoiaUser && member.status === 1)
				.map((member) => ({
					...member,
					fullName: `${member.firstName} ${member.lastName}`,
				}));
		},

		filterNumbersOnly (inputEvent) {
			if (/\D/.test(inputEvent.key)) {
				inputEvent.preventDefault();
			}
			return true;
		},
	},
	async mounted () {
		this.medicalStaff = await this.filterMedicalStaff();
		const [
			vaccineNameTemplate,
			vaccineSiteTemplate,
			vaccineRouteTemplate,
			vaccineDoseTemplate,
			vaccineManufacturerTemplate,
		] = await Promise.all([
			this.getVaccineNameTemplate(),
			this.getVaccineSiteTemplate(),
			this.getVaccineRouteTemplate(),
			this.getVaccineDoseTemplate(),
			this.getVaccineManufacturerTemplate(),
		]);
		this.vaccineNameTemplate = vaccineNameTemplate.data;
		this.vaccineSiteTemplate = vaccineSiteTemplate.data;
		this.vaccineRouteTemplate = vaccineRouteTemplate.data;
		this.vaccineDoseTemplate = vaccineDoseTemplate.data;
		this.vaccineManufacturerTemplate = vaccineManufacturerTemplate.data;

		this.performedBy = this.medicalStaff.find((staff) => staff.fullName === this.selectedVaccine.performedBy);
		if (this.vaccineNameTemplate.find((vaccine) => vaccine.name === this.selectedVaccine.vaccineName)) {
			this.selectedVaccineName = this.selectedVaccine.vaccineName;
		} else {
			this.selectedVaccineName = 'Other';
			this.otherVaccineName = this.selectedVaccine.vaccineName;
		}
		if (this.vaccineDoseTemplate.find((vaccine) => vaccine.dose === this.selectedVaccine.dose)) {
			this.selectedVaccineDose = this.selectedVaccine.dose;
		} else {
			this.selectedVaccineDose = 'Other';
			this.otherVaccineDose = this.selectedVaccine.dose;
		}
		if (this.vaccineRouteTemplate.find((vaccine) => vaccine.route === this.selectedVaccine.route)) {
			this.selectedVaccineRoute = this.selectedVaccine.route;
		} else {
			this.selectedVaccineRoute = 'Other';
			this.otherVaccineRoute = this.selectedVaccine.route;
		}
		if (this.vaccineSiteTemplate.find((vaccine) => vaccine.site === this.selectedVaccine.site)) {
			this.selectedVaccineSite = this.selectedVaccine.site;
		} else {
			this.selectedVaccineSite = 'Other';
			this.otherVaccineSite = this.selectedVaccine.site;
		}
		if (
			this.vaccineManufacturerTemplate.find((vaccine) => vaccine.manufacturer === this.selectedVaccine.manufacturer)
		) {
			this.selectedVaccineManufacturer = this.selectedVaccine.manufacturer;
		} else {
			this.selectedVaccineManufacturer = 'Other';
			this.otherVaccineManufacturer = this.selectedVaccine.manufacturer;
		}
		this.vaccinationDate = this.selectedVaccine.vaccinationDate;
		this.lotNumber = this.selectedVaccine.lotNumber;
		this.notes = this.selectedVaccine.notes;
	},

	watch: {
		selectedVaccine () {
			this.performedBy = this.medicalStaff.find((staff) => staff.fullName === this.selectedVaccine.performedBy);
			if (this.vaccineNameTemplate.find((vaccine) => vaccine.name === this.selectedVaccine.vaccineName)) {
				this.selectedVaccineName = this.selectedVaccine.vaccineName;
			} else {
				this.selectedVaccineName = 'Other';
				this.otherVaccineName = this.selectedVaccine.vaccineName;
			}
			if (this.vaccineDoseTemplate.find((vaccine) => vaccine.dose === this.selectedVaccine.dose)) {
				this.selectedVaccineDose = this.selectedVaccine.dose;
			} else {
				this.selectedVaccineDose = 'Other';
				this.otherVaccineDose = this.selectedVaccine.dose;
			}
			if (this.vaccineRouteTemplate.find((vaccine) => vaccine.route === this.selectedVaccine.route)) {
				this.selectedVaccineRoute = this.selectedVaccine.route;
			} else {
				this.selectedVaccineRoute = 'Other';
				this.otherVaccineRoute = this.selectedVaccine.route;
			}
			if (this.vaccineSiteTemplate.find((vaccine) => vaccine.site === this.selectedVaccine.site)) {
				this.selectedVaccineSite = this.selectedVaccine.site;
			} else {
				this.selectedVaccineSite = 'Other';
				this.otherVaccineSite = this.selectedVaccine.site;
			}
			if (
				this.vaccineManufacturerTemplate.find((vaccine) => vaccine.manufacturer === this.selectedVaccine.manufacturer)
			) {
				this.selectedVaccineManufacturer = this.selectedVaccine.manufacturer;
			} else {
				this.selectedVaccineManufacturer = 'Other';
				this.otherVaccineManufacturer = this.selectedVaccine.manufacturer;
			}
			this.vaccinationDate = this.selectedVaccine.vaccinationDate;
			this.lotNumber = this.selectedVaccine.lotNumber;
			this.notes = this.selectedVaccine.notes;
		},
	},
};
</script>
